/* eslint-disable */

import { each, trim } from 'lodash'

export default class Base {
  constructor(authentication) {
    this.authentication = authentication
  }

  get(path) {
    return this.fetch(path, { method: 'GET' })
  }

  fetch(path, opts = { method: 'GET' }) {
    const options = this.normalize(opts)
    const f = typeof fetch === 'undefined' ? () => Promise.resolve({}) : fetch
    return f(this.url(path), options)
      .then((response) => response.json())
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.error(error)
        }
        return {
          meta: { status: 500 },
          error: { title: 'Internal Server Error', detail: 'Something went horribly wrong.' },
        }
      })
  }

  // Move all code to absolute fetch
  absoluteFetch(path, opts = { method: 'GET' }) {
    const options = this.normalize(opts)

    const f = typeof fetch === 'undefined' ? () => Promise.resolve({}) : fetch
    return f(this.absoluteUrl(path), options)
      .then((response) => response)
      .catch((error) => ({ error }))
  }

  absoluteUrl(path) {
    const trimmed = trim(path, '/')
    return `${process.env.REACT_APP_ID_TILTIFY_URL}/${trimmed}`
  }

  url(path) {
    const trimmed = trim(path, '/')
    return `${this.host}/${trimmed}`
  }

  normalize(options) {
    options.credentials = 'include'
    const body = this.body(options)
    const headers = this.headers(options)
    return { ...options, body, headers }
  }

  get host() {
    return process.env.REACT_APP_ID_TILTIFY_URL
  }

  get railsParams() {
    const metaToken = document.querySelector('meta[name=csrf-token]')
    const metaParam = document.querySelector('meta[name=csrf-param]')
    const authenticity_token = metaToken && metaToken.content // eslint-disable-line
    const param = metaParam && metaParam.content
    return { authenticity_token, param, 'utf-8': '\u2713' }
  }

  headers({ body }) {
    const node = document.getElementsByName('t')[0]
    const token = (node && node.content) || null
    const headers = {}
    headers['X-CSRF-Token'] = token // eslint-disable-line
    headers['X-Requested-With'] = 'XMLHttpRequest'
    headers['Accept'] = 'application/json'
    if (body instanceof FormData) return headers
    headers['Content-Type'] = 'application/json'
    return headers
  }

  body({ body, method }) {
    if (method === 'GET') return void 0
    return body instanceof FormData ? this.formdata(body, method) : this.json(body, method)
  }

  formdata(body, method) {
    each(this.railsParams, (value, key) => body.append(key, value))
    body.append('_method', method)
    return body
  }

  json(body, method) {
    return JSON.stringify({
      ...body,
      _method: method,
      credentials: 'same-origin',
    })
  }
}
